import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "ngx-device-detector";
export class LoggerService {
    constructor(_http, _device) {
        this._http = _http;
        this._device = _device;
    }
    getIPAddress() {
        return this._http.get("https://api.ipify.org/?format=json");
    }
    logDevice() {
        if (!localStorage.getItem("seesion_id")) {
            var devInfo = this._device.getDeviceInfo();
            devInfo.client_UTC = new Date(Date.now()).toUTCString();
            devInfo.client_timestamp = new Date(Date.now()).toLocaleString();
            this.getIPAddress().subscribe((res) => {
                devInfo.ip_address = res.ip;
                this._http.post('/user/device', devInfo).toPromise().then((res) => {
                    localStorage.setItem("seesion_id", res);
                });
            });
            console.log(devInfo);
        }
    }
}
LoggerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DeviceDetectorService)); }, token: LoggerService, providedIn: "root" });
